var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const initAddProductsToCartButton = /* @__PURE__ */ __name(($el) => {
  const state = window.Alpine.reactive({
    element: $el,
    isAdding: false
  });
  const handleAddToCart = /* @__PURE__ */ __name(async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const productCards = state.element.closest("[data-section-type]").querySelectorAll("[data-product-id]");
    const bundleItems = [];
    productCards.forEach((card) => {
      card?._x_dataStack?.forEach((proxyState) => {
        if (proxyState?.card) {
          bundleItems.push({
            id: proxyState?.card?.selected_variant?.id,
            quantity: 1
          });
        }
      });
    });
    state.isAdding = true;
    const data = await _cart.add({
      items: bundleItems
    });
    state.isAdding = false;
    if (!data.cart_error) {
      _stores.modal.setId("cart-drawer");
      _stores.productDrawer.open = false;
      _stores.quickView.open = false;
    }
  }, "handleAddToCart");
  return {
    state,
    handleAddToCart
  };
}, "initAddProductsToCartButton");
window._sections["initAddProductsToCartButton"] = initAddProductsToCartButton;
